import React from 'react'
import { withRouter } from 'react-router-dom'
import Gallery from "../MainView/components/Gallery"


class AdminView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mediaType: "",
      loading: false
    }
  }

  componentDidMount(){
    const match = this.props.location.pathname
    const path = match.split("/")[2] || ""
    this.setState({
      mediaType: match === "/admin" ? "ringtones-wallpapers" : path
    })
  }

  onMediaChange = (value) => {
    this.setState({
      mediaType: value,
      fileList: [],
      loading: true
    }, () => {
      this.props.history.push(`/admin/${value}`)
      this.setState({
        loading: false
      })
    })
  }

  getFileList = (file) => {
    const { fileList } = this.state
    this.setState({fileList: fileList && fileList.length ? fileList.concat(file) : file})
  }

  render() {
    const { mediaType, fileList, loading } = this.state
    const { location } = this.props
    return (
      <div style={{paddingRight: 50, paddingLeft: 50}}>

        <div style={{display: "flex", marginTop: 20}}>
          <div
            className="col title"
            style={mediaType === "ringtones-wallpapers" ? {background: "#755b98", color: "#fff", borderBottomLeftRadius: 5, borderTopLeftRadius: 5} : {color: "#755b98", borderBottomLeftRadius: 5, borderTopLeftRadius: 5}}
            onClick={() => this.onMediaChange("ringtones-wallpapers")}
          >
            All
          </div>
          <div
            className="col title"
            style={mediaType === "ringtones" ? {background: "#755b98", color: "#fff"} : {color: "#755b98"}}
            onClick={() => this.onMediaChange("ringtones")}
          >
            Ringtones
          </div>
          <div
            className="col title"
            style={mediaType === "wallpapers" ? {background: "#755b98", color: "#fff", borderBottomRightRadius: 5, borderTopRightRadius: 5} : {color: "#755b98"}}
            onClick={() => this.onMediaChange("wallpapers")}
          >
            Wallpapers
          </div>
        </div>

        {
          loading ? <p>Loading...</p> :
            <div>
              {
                mediaType ?
                  <Gallery
                    onHandleDrop={this.onHandleDrop}
                    getFileList={this.getFileList}
                    fileList={fileList}
                    mediaType={mediaType}
                    path={(location && location.pathname) || ""}
                  /> : null
              }
            </div>
        }
      </div>
    );
  }
}


export default withRouter(AdminView)
